/**
 * Collection service for /variables API endpoint.
 * @author Michal Drewniak (michal@blaze.tech)
 */
import { inject, Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';

import { VariableInfo } from '@blaze-shared/api-contracts-domain';

@Injectable({ providedIn: 'root' })
export class VariablesCollectionService extends EntityCollectionServiceBase<VariableInfo> {
  // name property is unique and as such can be a primary key
  constructor() {
    const serviceElementsFactory = inject(EntityCollectionServiceElementsFactory);

    super(`variable`, serviceElementsFactory);
  }
}
